import { useMemo } from "react";
import { AbacAppKey } from "../../Constants/AbacConstants";
import { useGetUserFeatures } from "../../Queries/ABACQueries";
import { useFlags } from "launchdarkly-react-client-sdk";
import { IFeatureToggles } from "../../Typings/FeatureToggles";

export const useFeaturePermission = (featureName: string) => {
  const { data: userAuthorizedFeatures } = useGetUserFeatures();
  const { enableAbacFeatures } = useFlags<IFeatureToggles>();
  return useMemo(
    () =>
      enableAbacFeatures ? (userAuthorizedFeatures?.has(`${AbacAppKey}:${featureName}`) ?? false) : true,
    [userAuthorizedFeatures, featureName, enableAbacFeatures],
  );
};
